export enum VehicleTypeEnumerator {
  Any = 'any',
  New = 'new',
  Used = 'used',
  Cpo = 'cpo'
}
